module.exports = "query DuePassedIssuesCountQuery{duePassed:issues(closedAt_Isnull:true,duePassed:true){totalCount hasUnreadMessages}}"